// src/analytics/hotjar.js
export function setupHotjar(siteId, sv) {
  const id = siteId ?? Number(import.meta.env.VITE_HOTJAR_ID);
  const snippet = sv ?? Number(import.meta.env.VITE_HOTJAR_SV || 6);
  if (!import.meta.env.PROD || !id || window.hj) return;

  (function(h,o,t,j,a,r){
    h.hj = h.hj || function(){ (h.hj.q = h.hj.q || []).push(arguments) };
    h._hjSettings = {hjid: id, hjsv: snippet};
    a = o.getElementsByTagName('head')[0];
    r = o.createElement('script'); r.async = 1;
    r.src = `https://static.hotjar.com/c/hotjar-${id}.js?sv=${snippet}`;
    a.appendChild(r);
  })(window, document, null, null, null, null);
}

export function trackSpaRoute(path) { window.hj?.('stateChange', path); }
export function trackHotjarEvent(name, props={}) { window.hj?.('event', name, props); }
